/**
 * @generated SignedSource<<f372c3b9763a9498837c492fe1ec1e88>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type OrgCrawlTest = "GoogleApiAccessDisabled" | "GoogleContactSharingDisabled" | "NoCrawl" | "NoExternalOrganization" | "ShouldCrawl" | "Skipped" | "StartedCrawl" | "%future added value";
export type MaybeOnboardOrgMutationInput = {
  clientMutationId?: string | null;
  orgRelayId: string;
};
export type MaybeOnboardOrgMutation$variables = {
  input: MaybeOnboardOrgMutationInput;
};
export type MaybeOnboardOrgMutation$data = {
  readonly maybeOnboardOrg: {
    readonly crawlTest: OrgCrawlTest;
  } | null;
};
export type MaybeOnboardOrgMutation = {
  variables: MaybeOnboardOrgMutation$variables;
  response: MaybeOnboardOrgMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MaybeOnboardOrgMutationPayload",
    "kind": "LinkedField",
    "name": "maybeOnboardOrg",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "crawlTest",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MaybeOnboardOrgMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MaybeOnboardOrgMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "81936d74058be8a1633caada0f3905fb",
    "id": null,
    "metadata": {},
    "name": "MaybeOnboardOrgMutation",
    "operationKind": "mutation",
    "text": "mutation MaybeOnboardOrgMutation(\n  $input: MaybeOnboardOrgMutationInput!\n) {\n  maybeOnboardOrg(input: $input) {\n    crawlTest\n  }\n}\n"
  }
};
})();

(node as any).hash = "bea4902760d75df2dc3ca6f57cbcada2";

export default node;
